<template>
  <BaseChip :size="size" :theme="themeForStatus">
    • {{ $t(`${status.toUpperCase()}`) }}
  </BaseChip>
</template>

<script setup lang="ts">
import BaseChip from '@/components/generics/base/BaseChip.vue'
import { computed } from 'vue'

export type EventStatus = 'COMPLETED' | 'UPCOMING' | 'ONGOING' | 'CANCELLED'

const props = defineProps<{
  status: EventStatus
  size?: 'tiny' | 'small'
}>()

const themeForStatus = computed(() => {
  switch (props.status) {
    case 'COMPLETED':
      return 'new-leaf'
    case 'UPCOMING':
    case 'ONGOING':
      return 'portal-blue'
    case 'CANCELLED':
      return 'red-alert'
    default:
      return 'portal-blue'
  }
})
</script>
